import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseQueryParams',
  pure: true,
})
export class ParseQueryParamsPipe implements PipeTransform {
  transform(params: Record<string, string>): Record<string, string> | undefined {
    if (!params) {
      return;
    }

    return { [params.name]: params.searchTerms };
  }
}
